/** This export is automatically generated */
export const isoNow = '2025-05-05T09:57:39.332Z';
